var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"sidebar-minimizer-header",attrs:{"type":"button"},on:{"click":function($event){return _vm.onClick()}}},[_c('span',{staticClass:"navbar-toggler-icon"})])}
var staticRenderFns = []

export { render, staticRenderFns }